import _objectSpread from "D:/work/admin/project_nav_manage/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from "vuex";
import scroll from './mixins/normal';
export default {
  name: 'd2-container-full',
  mixins: [scroll],
  computed: _objectSpread({}, mapState("d2admin", {
    showDialog: function showDialog(state) {
      return state.method.showDialog;
    }
  })),
  data: function data() {
    return {
      isSlide: false
    };
  },
  created: function created() {},
  mounted: function mounted() {
    var _this = this;

    // 增加滚动事件监听
    this.addScrollListener();
    this.$bus.$on('isSlide', function (data) {
      _this.isSlide = data;
    });
  },
  beforeDestroy: function beforeDestroy() {
    // 移除滚动事件监听
    this.removeScrollListener();
  }
};